module.exports = __webpack_public_path__ + "static/media/Honne.c3ed3c2b.png";